<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">{{ $t("settings.productsNotFound") }}</h2>

    <div class="columns">
      <div class="column">
        <b-field :label="$t('settings.productsNotFoundDescription')">
          <b-switch
            size="is-small"
            class="product-not-found"
            type="is-primary"
            v-model="
              storeBeingManaged.configs.searchNotFoundProductsInMyOtherStores
            "
            passive-type="is-secondary"
            @input="setSearchNotFoundProductsInMyOtherStores"
          ></b-switch>

          {{
            storeBeingManaged.configs.searchNotFoundProductsInMyOtherStores
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged"])
  },

  methods: {
    setSearchNotFoundProductsInMyOtherStores() {
      this.isLoading = true;
      this.$store
        .dispatch("setSearchNotFoundProductsInMyOtherStores", {
          storeId: this.storeBeingManaged._id,
          status: this.storeBeingManaged.configs
            .searchNotFoundProductsInMyOtherStores
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: `${this.$t(
                "settings.searchNotFoundProductsInMyOtherStores"
              )} ${
                this.storeBeingManaged.configs
                  .searchNotFoundProductsInMyOtherStores
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          } else {
            this.storeBeingManaged.configs.searchNotFoundProductsInMyOtherStores = !this
              .storeBeingManaged.configs.searchNotFoundProductsInMyOtherStores;
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.storeBeingManaged.configs.searchNotFoundProductsInMyOtherStores = !this
            .storeBeingManaged.configs.searchNotFoundProductsInMyOtherStores;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.product-not-found-switch {
  position: relative;
  top: 2px;
}
</style>
